import { useEffect, useState } from "react";
import { SHIPMENTS_TAB, SHIPMENTS_TABLE_TABS } from "../../constants";
import { Box, Stack } from "@mui/material";
import { ActionIcon, BulkAction } from "../Icon";
import { Drawer } from "../Drawer";
import { BulkActionsDrawer } from "./BulkActionsDrawer/BulkActionsDrawer";
import { useAmazonWIrefresh } from "../../hooks/useAmazonWIRefresh";

export const ActionsHeader = ({ displayName, api, refreshData, setSnackBar }) => {
  const [selectedCount, setSelectedCount] = useState(0);
  const shipmentsTab = localStorage.getItem(SHIPMENTS_TAB);
  const [openBulkActionsDrawer, setOpenBulkActionsDrawer] = useState<boolean>(false);

  const [amazonWIrefreshPayloadData, setAmazonWIrefreshPayloadData] = useState();
  const [amazonWIrefetchEnable, setAmazonWIrefreshEnable] = useState<boolean>(false);

  //AmazonWi refresh API hook
  const { loadingAmazonWI, fetchingAmazonWI, errorFetchingAmazonWI, AmazonWIResponseData, fetchAmazonWIError, refetchAmazonWI } =
    useAmazonWIrefresh({ amazonWIdata: amazonWIrefreshPayloadData, enabled: amazonWIrefetchEnable });

  //Snackbar for the AmazonWI API response
  useEffect(() => {
    if (AmazonWIResponseData?.success === true) {
      setOpenBulkActionsDrawer(false);
      setSnackBar({
        open: true,
        message: AmazonWIResponseData?.message,
        severity: "success",
      });
      refreshData();
    } else if (AmazonWIResponseData?.success === false) {
      setOpenBulkActionsDrawer(false);
      setSnackBar({
        open: true,
        message: AmazonWIResponseData?.message,
        severity: "error",
      });
    }
  }, [AmazonWIResponseData, amazonWIrefetchEnable]);

  //Handle amazonWI api
  const handleOnSuccessfulAmazonWI = (selectedRows) => {
    setAmazonWIrefreshPayloadData(selectedRows);
    setAmazonWIrefreshEnable(true);
  };

  useEffect(() => {
    setAmazonWIrefreshEnable(false);
  }, [amazonWIrefetchEnable]);

  useEffect(() => {
    if (shipmentsTab != SHIPMENTS_TABLE_TABS.PRINT_HUB.value && api) {
      const updateSelectedCount = () => {
        const selectedNodes = api.getSelectedRows ? api.getSelectedRows() : [];
        setSelectedCount(selectedNodes?.length || 0);
      };

      api.addEventListener("selectionChanged", updateSelectedCount);
      api.addEventListener("modelUpdated", updateSelectedCount);
      updateSelectedCount();

      return () => {
        api.removeEventListener("selectionChanged", updateSelectedCount);
        api.removeEventListener("modelUpdated", updateSelectedCount);
      };
    }
  }, [api, shipmentsTab]); // Ensure the effect reruns when the api or shipmentsTab changes

  const handleSuccessfulUpdate = (updateActionResponseData) => {
    if (updateActionResponseData.success === true) {
      setOpenBulkActionsDrawer(!openBulkActionsDrawer);
      setSnackBar({
        open: true,
        message: "Successfully Dispatched",
        severity: "success",
      });
      refreshData();
    } else {
      setOpenBulkActionsDrawer(!openBulkActionsDrawer);
      setSnackBar({
        open: true,
        message: " The Action update not success",
        severity: "error",
      });
    }
  };

  return (
    <>
      <Stack direction="row" spacing={1} alignItems="center">
        <div>{displayName}</div>
        {shipmentsTab != SHIPMENTS_TABLE_TABS.PRINT_HUB.value && selectedCount > 0 && (
          <Box
            onClick={() => setOpenBulkActionsDrawer(!openBulkActionsDrawer)}
            sx={{
              cursor: "pointer",
            }}
          >
            <ActionIcon />
          </Box>
        )}
      </Stack>
      <Drawer open={openBulkActionsDrawer} onClose={() => setOpenBulkActionsDrawer(!openBulkActionsDrawer)}>
        <BulkActionsDrawer
          selectedRows={api.getSelectedRows()}
          onSuccessfulUpdate={handleSuccessfulUpdate}
          onSuccessfulAmazonRefresh={handleOnSuccessfulAmazonWI}
        />
      </Drawer>
    </>
  );
};
